// Visual stamp shown after a document has been signed.
// Used inside SignatureWidget and on signed-document views.

const formatDate = (input) => {
  if (!input) return '';
  const d = input.toDate ? input.toDate() : new Date(input);
  return d.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

const SignatureMark = ({ signature, compact = false }) => {
  if (!signature) return null;
  const name = signature.signedByName || 'Signed';

  if (compact) {
    return (
      <div className="inline-flex items-center gap-2">
        <span className="text-success text-sm">✓</span>
        <span className="font-serif text-base-content">{name}</span>
        <span className="text-xs text-base-content/50">
          {formatDate(signature.signedAt)}
        </span>
      </div>
    );
  }

  return (
    <div className="inline-flex flex-col items-start gap-1 px-4 py-3 rounded-lg border border-success/30 bg-success/5">
      <div className="flex items-center gap-2">
        <span className="text-success text-base">✓</span>
        <span className="text-xs uppercase tracking-widest text-success/80 font-semibold">
          Signed
        </span>
      </div>
      <div className="font-serif text-xl text-base-content leading-tight">{name}</div>
      <div className="text-xs text-base-content/50">
        {formatDate(signature.signedAt)}
      </div>
    </div>
  );
};

export default SignatureMark;
